import { Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'brightside-web-helping-hands-upload-card',
    imports: [BrightsideUiModule],
    templateUrl: './helping-hands-upload-card.component.html',
    styleUrl: './helping-hands-upload-card.component.css'
})
export class HelpingHandsUploadCardComponent {
  data: { route: string; state: string };
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);

  ngOnInit() {
    this.actionCardConfig = {
      label: this._translateSvc.instant('TAKE_ACTION'),
      labelSub: this._translateSvc.instant('HELPING_HANDS_UPLOAD_MINUTES'),
      title: this._translateSvc.instant('HELPING_HANDS_UPLOAD_TITLE'),
      body: this._translateSvc.instant('HELPING_HANDS_UPLOAD_DESC'),
      labelSubRemoveDash: true,
      cardStyle: 'small',
      labelIcon: 'icon-actions',
      marginBottom: 'small'
    };
  }

  navigate() {    
    this._router.navigateByUrl(this.data.route);
  }
}
